import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { CARD_NAME_MAX_LENGTH } from 'const/limits'
import {
  NavbarBreadcrumb,
  NavbarBreadcrumbItem,
  NavbarLabel,
} from 'components/Navbar'
import EditableModal from 'components/EditableModal'
import KanBoIcon from 'components/KanBoIcon'
import Menu from './Menu'
import styled from 'styled-components'
import { withBoardPermission } from 'dataProviders/Board'
import {
  ModalMenu
} from 'components/Modal'
import {
  MenuItem
} from 'components/Menu'

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: -7px;
  margin-bottom: -9px;
  font-size: 14px;
`

export class Breadcrumb extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,

    permission: PropTypes.object.isRequired,

    isArchived: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    isTemplate: PropTypes.bool.isRequired,
    isObserved: PropTypes.bool.isRequired,

    requestChangeCardName: PropTypes.func.isRequired,
    requestFollowCard: PropTypes.func.isRequired,
  }

  handleNameEditableValidate = (values) => {
    const errors = {}
    if (!values.name) {
      errors.name = this.props.intl.formatMessage({ id: 'CARD_NAME_EMPTY' })
    } else if (values.name.length > CARD_NAME_MAX_LENGTH) {
      errors.name = this.props.intl.formatMessage({ id: 'CARD_NAME_TOO_LONG' }, { limit: CARD_NAME_MAX_LENGTH })
    }
    return errors
  }

  handleNameEditableSubmit = ({ name }) => {
    if (name && name !== this.props.name) {
      this.props.requestChangeCardName({
        cardId: this.props.id,
        name
      })
    }
  }

  renderIsTemplate = () => {
    const {
      isTemplate
    } = this.props

    return isTemplate ? (
      <NavbarLabel
        bsStyle='primary'
        icon={<KanBoIcon name='kanbo-16-template' />}
      >
        <FormattedMessage id='CARD_TEMPLATE_LABEL' />
      </NavbarLabel>
    ) : null
  }

  renderIsObserved = () => {
    const {
      id,
      isObserved,
      requestFollowCard,
    } = this.props

    return isObserved ? (
      <ModalMenu>
        <NavbarLabel
          bsStyle='primary'
          icon={<KanBoIcon name='kanbo-16-follow' />}
        />
        <MenuItem
          icon={<KanBoIcon fixedWidth name='kanbo-24-unfollowing' />}
          onClick={() => {
            requestFollowCard({
              cardId: id,
              isObserved: false
            })
          }}
        >
          <FormattedMessage id='UNFOLLOW' />
        </MenuItem>
      </ModalMenu>
    ) : null
  }

  renderName = () => {
    const {
      name,
    } = this.props

    return (
      <NavbarBreadcrumbItem>
        {name}
      </NavbarBreadcrumbItem>
    )
  }

  renderNameContainer = () => {
    const {
      name,
      permission,
      isArchived
    } = this.props

    if (!isArchived && permission.member) {
      return (
        <EditableModal
          initialValues={{ name }}
          onSubmit={this.handleNameEditableSubmit}
          validate={this.handleNameEditableValidate}
        >
          {this.renderName()}
        </EditableModal>
      )
    } else {
      return this.renderName()
    }
  }
  render () {
    return (
      <StyledDiv>
        <NavbarBreadcrumb>
          {this.renderNameContainer()}
        </NavbarBreadcrumb>
        {this.renderIsTemplate()}
        {this.renderIsObserved()}
        <Menu />
      </StyledDiv>
    )
  }
}

export default injectIntl(withBoardPermission(Breadcrumb))
